const { h, render, Component } = require('preact');
const CommonStatus = require('./common_status')
class StatusInfo extends Component {
  constructor() {
    super();
  }
  render({order}) {
    if(!order.status.dateInfo)
      return null
    return (<CommonStatus landingView = {this.props.landingView} label={order.status.dateInfo.label} value={order.status.dateInfo.value}/>)
  }
}
module.exports = StatusInfo
